import { render, staticRenderFns } from "./brandModel.vue?vue&type=template&id=0192b4a7&scoped=true&"
import script from "./brandModel.vue?vue&type=script&lang=js&"
export * from "./brandModel.vue?vue&type=script&lang=js&"
import style0 from "./brandModel.vue?vue&type=style&index=0&id=0192b4a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0192b4a7",
  null
  
)

export default component.exports